exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "ul[data-v-9b9ba008]{box-shadow:0 2px 2px hsla(38,16%,76%,.5);padding:0;list-style:none;background:#fff}ul li[data-v-9b9ba008]{padding:5px 19px}ul li.active[data-v-9b9ba008],ul li[data-v-9b9ba008]:hover{background:#f8f8f8;color:#127281}ul p[data-v-9b9ba008]{cursor:pointer;margin:0}ul small[data-v-9b9ba008]{font-size:.6em;color:#127281}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9b9ba008","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?data=@import "./src/scss/base";!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/js/components/engagement/cachedterms/CachedTerms.vue
// module id = 805
// module chunks = 1